:host {
  display: block;
}

:host(:not([dir=rtl])) .rainbow-bar__gray::before {
  box-shadow: none;
}

.rainbow-bar {
  min-width: 130px;
  height: 5px;
  border-radius: 2.5px;
  position: relative;
  overflow: hidden;
}

@media screen and (max-width: 719px) {
  .rainbow-bar {
    min-width: 90px;
  }
}

.rainbow-bar__progress {
  height: 5px;
  position: absolute;
  border-radius: 2.5px;
  top: 0;
  bottom: 0;
  width: 100%;
}

:host(:not([dir="rtl"])) .rainbow-bar__progress {
  left: 0;
  background: linear-gradient(to right, #3dcd58 49%, #ffd100 89%, #e47f00 96%, #b10043 100%);
}

:host([dir="rtl"]) .rainbow-bar__progress {
  right: 0;
  background: linear-gradient(to left, #3dcd58 49%, #ffd100 89%, #e47f00 96%, #b10043 100%);
}

.rainbow-bar__progress--error {
  background: #b10043 !important;
}

.rainbow-bar__gray {
  height: 5px;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: #e6e6e6;
  width: 0;
  border-radius: 0;
}

:host(:not([dir="rtl"])) .rainbow-bar__gray {
  right: -12px;
}

:host([dir="rtl"]) .rainbow-bar__gray {
  left: -12px;
}

.rainbow-bar__gray::before {
  content: "";
  display: block;
  position: relative;
  width: 36px;
  height: 100%;
  box-shadow: 11px 0 0 0 #e6e6e6;
}

:host(:not([dir="rtl"])) .rainbow-bar__gray::before {
  border-top-right-radius: 54px;
  border-bottom-right-radius: 54px;
  left: -48px;
}

:host([dir="rtl"]) .rainbow-bar__gray::before {
  border-top-left-radius: 54px;
  border-bottom-left-radius: 54px;
  right: -48px;
}

.rainbow-bar__gray::after {
  content: "";
  position: absolute;
  display: block;
  height: 100%;
  background-color: #e6e6e6;
  width: 20px;
  top: 0;
}

:host(:not([dir="rtl"])) .rainbow-bar__gray::after {
  left: -12px;
}

:host([dir="rtl"]) .rainbow-bar__gray::after {
  right: -12px;
}